import React, { Component, ChangeEvent, FormEvent } from "react";
import Illustration2FA from "../asset/img/2FA.svg";
import CardDecoration from "../asset/img/Card-Decoration.svg";
import Logo from "../asset/img/ppu-logo-signin.png";

import moment from "moment";
import { Link, Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import AuthAPI from "../api/Auth";
import Loading from "../components/Loading";

import microsoftLogo from "../../src/asset/img/microsoft.png";
import { withMsal, WithMsalProps } from "@azure/msal-react";
import { msalConfig } from "../api/msalConfig";

export const loginRequest = {
  scopes: ["User.Read"],
  responseMode: "query"
};

interface LoginProps extends RouteComponentProps, WithMsalProps {}

interface LoginState {
  isLoading: boolean;
  show: "login" | "error" | "2fa" | "none";
  redirect: React.ReactNode | null;
  app_id: string | null;
  redirect_uri: string | null;
  data: {
    username: string;
    password: string;
  };
  error: {
    title: string;
    subtitle: string;
  };
  code: string;
}

class Login extends Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);

    const params = new URLSearchParams(this.props.location.search);

    this.state = {
      isLoading: false,
      show: "none",
      redirect: null,
      app_id: params.get("app_id"),
      redirect_uri: params.get("redirect_uri"),
      data: {
        username: "",
        password: "",
      },
      error: {
        title: "",
        subtitle: "",
      },
      code: "",
    };
  }

  /* ================== FORM ================== */
  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState((prev) => ({
      data: { ...prev.data, [name]: value },
      error: { title: "", subtitle: "" },
    }));
  };

  handleLogin = (event: FormEvent) => {
    event.preventDefault();
    this.setState({ isLoading: true }, () => {
      const body = new URLSearchParams({
        username: this.state.data.username,
        password: this.state.data.password,
        clientId: this.state.app_id ?? process.env.REACT_APP_APP_ID ?? "",
      });

      AuthAPI.login(body).then((data: any) => {
        if (data.status === 200) {
          if (typeof data.data === "string" && data.data.includes("not verified")) {
            this.setState({ isLoading: false }, () => {
              toast.error(
                "Akun Anda belum Terverifikasi, Silahkan Cek Email Anda untuk Melakukan Verifikasi",
                { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 8000 }
              );
            });
          } else if (typeof data.data === "string") {
            this.setState({ isLoading: false, show: "2fa" });
          } else {
            this.processGetToken(data);
          }
        } else if (data.status === 403) {
          this.setState({
            isLoading: false,
            show: "error",
            error: {
              title: "Akses Tidak Dimiliki",
              subtitle: "Akun yang Anda gunakan tidak memiliki akses untuk masuk ke dalam aplikasi.",
            },
          });
        } else {
          const error = {
            title: "Terjadi Kesalahan",
            subtitle: "Telah terjadi kesalahan, silahkan coba beberapa saat lagi.",
          };

          if (data.status === 400) {
            if (
              data.message === "Wrong Password/Username" ||
              data.message === "Cannot read properties of null (reading 'isValidPassword')"
            ) {
              error.title = "Username/Password Salah";
              error.subtitle = "";
            } else if (data.message === "Application not found") {
              error.title = "Aplikasi Tidak Tersedia";
              error.subtitle = "Aplikasi yang anda tuju tidak ditemukan atau tidak terdaftar didalam sistem.";
            }
          }

          this.setState({
            isLoading: false,
            show: error.subtitle === "" ? this.state.show : "error",
            error,
          });
        }
      });
    });
  };

  processGetToken = (data: any) => {
    AuthAPI.getToken(data.sso_code).then((result: any) => {
      localStorage.setItem("local_session", result.local_session);
      localStorage.setItem("session_time", Date.now().toString());
      localStorage.setItem("announcement", "no");
      if (this.state.app_id && this.state.redirect_uri) {
        window.location.href = `${this.state.redirect_uri}?sso_code=${data.sso_code}&username=${this.state.data.username}`;
      } else {
        localStorage.setItem("token", result.access_token);
        localStorage.setItem("refresh_token", result.refresh_token);
        window.location.reload();
      }
    });
  };

  /* ================== RELOGIN ================== */
  handleRelogin = () => {
    this.setState({ isLoading: true }, () => {
      const data_form = new URLSearchParams({
        clientId: this.state.app_id ?? "",
        sessionId: localStorage.getItem("local_session") ?? "",
      });

      AuthAPI.relogin(data_form).then((data: any) => {
        if (data.status === 200) {
          AuthAPI.getToken(data.sso_code).then((result: any) => {
            localStorage.setItem("local_session", result.local_session);
            localStorage.setItem("session_time", Date.now().toString());
            localStorage.setItem("announcement", "no");
            window.location.replace(
              `${this.state.redirect_uri}?sso_code=${data.sso_code}&username=${result.username}`
            );
          });
        } else if (data.status === 403) {
          this.setState({
            isLoading: false,
            show: "error",
            error: {
              title: "Akses Tidak Dimiliki",
              subtitle: "Akun yang Anda gunakan tidak memiliki akses untuk masuk ke dalam aplikasi.",
            },
          });
        } else if (data.status === 401) {
          localStorage.clear();
          this.reset();
        } else {
          this.setState({
            isLoading: false,
            show: "error",
            error: {
              title: "Terjadi Kesalahan",
              subtitle: "Telah terjadi kesalahan, silahkan coba beberapa saat lagi.",
            },
          });
        }
      });
    });
  };

  /* ================== 2FA ================== */
  handleCode = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const lastChar = value.charAt(value.length - 1);
    if ((lastChar >= "0" && lastChar <= "9") || value === "") {
      if (value.length <= 5) {
        this.setState({
          code: value,
          error: { title: "", subtitle: "" },
        });
      }
    }
  };

  verify2fa = (event: FormEvent) => {
    event.preventDefault();
    this.setState({ isLoading: true }, () => {
      const body = new URLSearchParams({
        username: this.state.data.username,
        otp: this.state.code,
        clientId: this.state.app_id ?? process.env.REACT_APP_APP_ID ?? "",
      });

      AuthAPI.verify(body).then((data: any) => {
        if (data.status === 200) {
          AuthAPI.getToken(data.sso_code).then((result: any) => {
            localStorage.setItem("local_session", result.local_session);
            localStorage.setItem("session_time", Date.now().toString());
            localStorage.setItem("announcement", "no");
            if (this.state.redirect_uri) {
              window.location.href = `${this.state.redirect_uri}?sso_code=${data.sso_code}&username=${this.state.data.username}`;
            } else {
              localStorage.setItem("token", result.access_token);
              localStorage.setItem("refresh_token", result.refresh_token);
              window.location.reload();
            }
          });
        } else if (data.status === 403) {
          this.setState({
            isLoading: false,
            show: "error",
            error: {
              title: "Akses Tidak Dimiliki",
              subtitle: "Akun yang Anda gunakan tidak memiliki akses untuk masuk ke dalam aplikasi.",
            },
          });
        } else {
          this.setState({
            isLoading: false,
            error: { title: "Kode verifikasi salah", subtitle: "" },
          });
        }
      });
    });
  };

  /* ================== RESET ================== */
  reset = () => {
    const params = new URLSearchParams(this.props.location.search);
    this.setState({
      isLoading: false,
      show: "login",
      app_id: params.get("app_id"),
      redirect_uri: params.get("redirect_uri"),
      data: { username: "", password: "" },
      error: { title: "", subtitle: "" },
      code: "",
    });
  };

  /* ================== MICROSOFT LOGIN ================== */
  handleMicrosoftLogin = async () => {
    console.log("BUTTON CLICKED, ready to call loginRedirect");
    const { instance } = this.props.msalContext;

    if (this.state.app_id) {
      localStorage.setItem("ms_app_id", this.state.app_id);
    } else {
      localStorage.removeItem("ms_app_id");
    }
    if (this.state.redirect_uri) {
      localStorage.setItem("ms_redirect_uri", this.state.redirect_uri);
    } else {
      localStorage.removeItem("ms_redirect_uri");
    }

    try {
      await instance.loginRedirect(loginRequest);
    } catch (err: any) {
      alert("Error: " + (err.errorCode || err.message));
    }
  };

  /* ================== LIFECYCLE ================== */
  componentDidMount() {
    let session = localStorage.getItem("local_session");

    if (session) {
      const now = moment(Date.now());
      const time = moment(Number(localStorage.getItem("session_time")));
      if (now.diff(time, "hour") > 22) {
        localStorage.clear();
        session = null;
      }
    }

    const { instance } = this.props.msalContext;
    instance.handleRedirectPromise().then((tokenResponse) => {
      if (tokenResponse) {
          // localStorage.setItem("ms_access_token", tokenResponse.accessToken);
          // localStorage.setItem("ms_account", JSON.stringify(tokenResponse.account));
          // localStorage.setItem("local_session", "true");
          // localStorage.setItem("session_time", Date.now().toString());
          const body = new URLSearchParams({
            clientId: this.state.app_id ?? process.env.REACT_APP_APP_ID ?? "",
            idTokenEntra: tokenResponse?.account?.idToken!,
          });
          AuthAPI.login(body).then((data: any) => {
          if (data.status === 200) {
            if (typeof data.data === "string" && data.data.includes("not verified")) {
              this.setState({ isLoading: false }, () => {
                toast.error(
                  "Akun Anda belum Terverifikasi, Silahkan Cek Email Anda untuk Melakukan Verifikasi",
                  { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 8000 }
                );
              });
            } else if (typeof data.data === "string") {
              this.setState({ isLoading: false, show: "2fa" });
            } else {
              this.processGetToken(data);
            }
          } else if (data.status === 403) {
            this.setState({
              isLoading: false,
              show: "error",
              error: {
                title: "Akses Tidak Dimiliki",
                subtitle: "Akun yang Anda gunakan tidak memiliki akses untuk masuk ke dalam aplikasi.",
              },
            });
          } else {
            const error = {
              title: "Terjadi Kesalahan",
              subtitle: "Telah terjadi kesalahan, silahkan coba beberapa saat lagi.",
            };

            if (data.status === 400) {
              if (
                data.message === "Wrong Password/Username" ||
                data.message === "Cannot read properties of null (reading 'isValidPassword')"
              ) {
                error.title = "Username/Password Salah";
                error.subtitle = "";
              } else if (data.message === "Application not found") {
                error.title = "Aplikasi Tidak Tersedia";
                error.subtitle = "Aplikasi yang anda tuju tidak ditemukan atau tidak terdaftar didalam sistem.";
              }
            }

            this.setState({
              isLoading: false,
              show: error.subtitle === "" ? this.state.show : "error",
              error,
            });
          }
        });
      }

      if (this.state.app_id && this.state.redirect_uri) {
        if (session) {
          this.handleRelogin();
        } else {
          this.setState({ show: "login" });
        }
      } else {
        if (session) {
          this.setState({
            show: "login",
            redirect: <Redirect to="/" />,
          });
        } else {
          this.setState({ show: "login" });
        }
      }
    }).catch((err) => {
      // console.error("Gagal ambil token dari redirect:", err);
      this.setState({ show: "login" });
    });
  }


  /* ================== RENDER ================== */
  render() {
    if (this.state.show === "login" || this.state.show === "error") {
      return (
        <React.Fragment>
          {this.state.redirect}
          <Loading show={this.state.isLoading} />
          <div className="login-root d-flex align-items-center justify-content-center">
            <div className="login-card">
              <div className="row">
                {/* LEFT PANEL */}
                <div className="login-card-header col-md-6 p-0 d-flex flex-column align-items-center justify-content-between">
                  <div />
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <img className="login-logo" src={Logo} alt="Logo Kota Semarang" />
                    <h1>Single Sign On</h1>
                    <div className="subtitle">Politeknik Pekerjaan Umum</div>
                  </div>
                  <img className="login-card-decoration" src={CardDecoration} alt="Card Decoration" />
                </div>

                {/* RIGHT PANEL */}
                {this.state.show === "login" ? (
                  <div className="login-card-body col-md-6 d-md-block d-flex flex-column justify-content-between">
                    <div className="login-card-head d-none d-md-block">
                      <div className="login-card-title">Login</div>
                      <div className="login-card-subtitle">
                        Silahkan gunakan akun yang Anda miliki untuk dapat melanjutkan
                      </div>
                    </div>
                    <form onSubmit={this.handleLogin}>
                      <div className="mb-3">
                        <label className="form-label">Username / nim / nip / email</label>
                        <input
                          value={this.state.data.username}
                          onChange={this.handleChange}
                          type="text"
                          name="username"
                          className={"form-control form-control-sm " + (this.state.error.title !== "" && "is-invalid")}
                          autoComplete="username"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                          value={this.state.data.password}
                          onChange={this.handleChange}
                          type="password"
                          name="password"
                          className={"form-control form-control-sm " + (this.state.error.title !== "" && "is-invalid")}
                          autoComplete="current-password"
                        />
                        <div className="invalid-feedback">{this.state.error.title}</div>
                      </div>
                      <div className="other-action mt-0 mb-3">
                        <Link to="/reset-password" className="back-to-app">Lupa Password?</Link>
                      </div>
                      <button type="submit" className="btn btn-sm btn-submit-login">Masuk</button>
                    </form>

                    <div className="text-center my-3 text-muted" style={{ fontSize: "12px" }}>ATAU</div>

                    <button onClick={this.handleMicrosoftLogin} style={{display: "flex", width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 12, borderWidth: 1, backgroundColor: 'white',   borderColor: '#8C8C8C', borderStyle: 'solid', height: 41}}>
                      <img src={microsoftLogo} width={21} height={21} />
                      <span style={{fontSize: 15, fontWeight: 600, color: '#5E5E5E'}}>Sign in with Microsoft</span>
                    </button>
                    {this.state.redirect_uri ? (
                      <div className="other-action">
                        <a className="back-to-app" href={this.state.redirect_uri}>
                          <svg className="feather feather-arrow-left me-2" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12"></line>
                            <polyline points="12 19 5 12 12 5"></polyline>
                          </svg>
                          <span>Kembali ke Aplikasi</span>
                        </a>
                      </div>
                    ) : (
                      <div className="other-action">
                        <Link to="/register" className="back-to-app">
                          Tidak memiliki akun? Daftar disini
                        </Link>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="login-card-body col-md-6 d-md-block d-flex flex-column justify-content-between"
                    style={{ paddingTop: "8rem", paddingBottom: "8rem" }}
                  >
                    <div className="login-card-head d-block text-center mb-5">
                      <div className="login-card-title">{this.state.error.title}</div>
                      <div className="login-card-subtitle">{this.state.error.subtitle}</div>
                    </div>
                    <button onClick={this.reset} className="btn btn-sm btn-submit-login">
                      Login Ulang
                    </button>
                    {this.state.redirect_uri && (
                      <div className="other-action mt-4 text-center">
                        <a className="back-to-app" href={this.state.redirect_uri}>
                          <svg className="feather feather-arrow-left me-2" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12"></line>
                            <polyline points="12 19 5 12 12 5"></polyline>
                          </svg>
                          <span>Kembali ke Aplikasi</span>
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.show === "2fa") {
      return (
        <React.Fragment>
          <Loading show={this.state.isLoading} />
          <div className="login-root d-flex align-items-center justify-content-center">
            <div className="card-2fa">
              <div className="card-2fa-body d-flex flex-column justify-content-between">
                <div className="card-2fa-illustration">
                  <img src={Illustration2FA} alt="" />
                </div>
                <div className="card-2fa-head text-center">
                  <div className="card-2fa-title">Autentikasi Dua-Faktor</div>
                  <div className="card-2fa-subtitle">
                    Untuk dapat melanjutkan, silahkan masukkan kode verifikasi yang telah dikirim ke email anda.
                  </div>
                </div>
                <form onSubmit={this.verify2fa}>
                  <div className="mb-3">
                    <input
                      onChange={this.handleCode}
                      value={this.state.code}
                      type="tel"
                      name="code"
                      className={"text-center form-control form-control-sm " + (this.state.error.title !== "" && "is-invalid")}
                      autoFocus
                    />
                    <div className="invalid-feedback text-center">{this.state.error.title}</div>
                  </div>
                  <button type="submit" className="btn btn-sm btn-submit-login">Verifikasi</button>
                </form>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

export default withMsal(withRouter(Login));